import React from 'react';
import './App.css';

const App = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.name}>Dinesh Sonachalam</h1>
      <p style={styles.title}>Software Engineering Manager @ PwC, London</p>

      <section style={styles.section}>
        <p>
          I'm a software engineering manager focused on scalable cloud-native solutions using GCP, Terraform,
          and microservices. I lead cross-functional teams, build secure backend systems, and drive
          high-quality software delivery.
        </p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>Experience</h2>
        <p><strong>PwC – Manager (2022–Present)</strong></p>
        <ul>
          <li>Built serverless systems on GCP</li>
          <li>Led 5-engineer team using Terraform, Node.js, React</li>
          <li>🏆 Led PwC team to win Agentic Era Hackathon by Google Cloud — competed against 200+ companies across Europe.</li>
        </ul>
        <p><strong>Intelsat – Senior Software Engineer (2019–2022)</strong></p>
        <ul>
          <li>Developed AWS Lambda-based UI sync service for aircrafts.</li>
          <li>Led React + Flask web app for aircraft maintenance</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.heading}>Contact</h2>
        <p>Email: <a href="mailto:dineshsonachalam@gmail.com">dineshsonachalam@gmail.com</a></p>
        <p>
          <a href="https://linkedin.com/in/dineshsonachalam">LinkedIn</a> |{" "}
          <a href="https://github.com/dineshsonachalam">GitHub</a> |{" "}
          <a href="https://dineshsonachalam.medium.com">Medium</a>
        </p>
      </section>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'sans-serif',
    maxWidth: 700,
    margin: '0 auto',
    padding: '2rem',
    lineHeight: 1.6,
  },
  name: {
    fontSize: '2rem',
    marginBottom: 0,
  },
  title: {
    fontSize: '1rem',
    color: '#555',
    marginBottom: '2rem',
  },
  section: {
    marginBottom: '2rem',
  },
  heading: {
    fontSize: '1.2rem',
    marginBottom: '0.5rem',
  },
};

export default App;
